"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var NO_SELECTOR = "NO_COMPONENT_SELECTOR";

function isStyledComponent(comp) {
  return Boolean(comp && typeof comp.styledComponentId === "string");
}

function isEmotion(comp) {
  // eslint-disable-next-line no-underscore-dangle
  return Boolean(comp && comp.__emotion_real);
}

function isReuse(comp) {
  return Boolean(comp && Array.isArray(comp.uses));
}

function hasSelector(comp) {
  return Boolean(comp && typeof comp.selector === "string");
}

function getSelector(comp) {
  if (typeof comp === "string") {
    return ".".concat(comp);
  }

  if (isStyledComponent(comp)) {
    return ".".concat(comp.styledComponentId);
  }

  if (isEmotion(comp)) {
    return comp.toString();
  }

  if (isReuse(comp)) {
    return comp.uses.filter(function (x) {
      return typeof x !== "string";
    }).map(getSelector).filter(function (x) {
      return x && x !== NO_SELECTOR;
    }).join("");
  }

  if (hasSelector(comp)) {
    return comp.selector;
  }

  return NO_SELECTOR;
}

var _default = getSelector;
exports.default = _default;